'use strict';
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
          enumerable: true,
          get: function () {
            return m[k];
          },
        });
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
var __setModuleDefault =
  (this && this.__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', { enumerable: true, value: v });
      }
    : function (o, v) {
        o['default'] = v;
      });
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
exports.__esModule = true;
exports.PluginsConsumer = void 0;
var lodash_1 = require('lodash');
var react_1 = __importStar(require('react'));
var ui_plugin_1 = require('ui-plugin');
function PluginsConsumer(_a) {
  var children = _a.children;
  var plugins = usePlugins();
  return (
    // TS isn't happy with function components returning non-JSX.Elements
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    react_1['default'].createElement(
      react_1['default'].Fragment,
      null,
      children({
        plugins: plugins,
        enable: function (pluginName, enabled) {
          return ui_plugin_1.enablePlugin(pluginName, enabled);
        },
      }),
    )
  );
}
exports.PluginsConsumer = PluginsConsumer;
function usePlugins() {
  var _a = react_1.useState(getPluginArray()),
    plugins = _a[0],
    setPlugins = _a[1];
  react_1.useEffect(
    function () {
      return ui_plugin_1.onPluginLoad(function () {
        var newPlugins = getPluginArray();
        if (!lodash_1.isEqual(newPlugins, plugins)) setPlugins(newPlugins);
      });
    },
    [plugins],
  );
  return plugins;
}
function getPluginArray() {
  var allPlugins = ui_plugin_1.getPlugins();
  return Object.keys(allPlugins).map(function (pluginName) {
    return allPlugins[pluginName];
  });
}
